import React, { useEffect } from 'react';
import { Link as RouterLink, useSearchParams } from "react-router-dom";
import { Alert, Box, IconButton } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import CostUploadHistoryTable from '../../shared/CostUploadHistoryTable/CostUploadHistoryTable';
import { useUploadHistory } from "./CostUploadHistory.hooks";
import classes from "./CostUploadHistory.module.css";
const CostUploadHistory = () => {
    const [searchParams] = useSearchParams();
    const batchId = searchParams.get("batchId");
    const { uploadHistory, page, setPage,  loading} = useUploadHistory(batchId);
    useEffect(() => {
        setPage(0);
    }, [setPage])
    return (
        <div>
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <IconButton
                    component={RouterLink}
                    to="/dc-cost/approvals"
                    aria-label="Back to DC Flow"
                    size="small"
                >
                    <ArrowBackIcon />
                </IconButton>
                <div className={classes.heading}>Cost Upload History</div>
            </Box>
            {batchId && !loading && uploadHistory.length === 0 && (
                <Alert severity="info" sx={{ margin: 2 }}>
                    No generated cost files are available for batch {batchId}. Cost files are created after items are approved or drafted.
                </Alert>
            )}
            <CostUploadHistoryTable
                uploadHistory={uploadHistory}
                isPaginationRequired={true}
                currentPage={page}
                loading={loading}
            />
        </div>
    );
};

export default CostUploadHistory;
